import ReactDOM from 'react-dom/client';

import App from './App';

import 'src/common/infra/translations/index';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
